import { render, staticRenderFns } from "./GoalsOverviewTable.vue?vue&type=template&id=0ead5452"
import script from "./GoalsOverviewTable.vue?vue&type=script&lang=ts"
export * from "./GoalsOverviewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports